import { Box, Drawer, List, ListItemIcon, ListItemText } from '@mui/material'
import styled from 'styled-components'
import { COLORS } from 'utils'

interface IDrawer {
  hide?: boolean
}
export const DrawerContainer = styled(Drawer)<IDrawer>`
  visibility: ${({ hide }) => hide && 'hidden'};
`

interface IDrawerContent {
  isOpen: boolean
}
export const DrawerContent = styled.div<IDrawerContent>`
  width: ${({ isOpen }) => (isOpen ? '252px' : '95px')};
`

export const DrawerHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 43px;
`

export const Drawermain = styled(Box)``
interface IListItemText {
  selected?: boolean
}
export const ListItemTextStyled = styled(ListItemText)<IListItemText>`
  color: ${COLORS.blueFonts};
  height: 47px;

  padding: 8px;
  display: flex;
  align-items: center;

  span {
    font-weight: 700 !important;
    font-size: 13px !important;
  }
`

export const ListStyled = styled(List)`
  height: 100%;
  overflow-y: auto;

  .subMenus {
    transition: 0.2s all;
    :hover {
      background: ${COLORS.primary};
    }
  }
  li {
    padding-left: 0;
    padding-right: 0;
    cursor: pointer;
    

    :hover {
      .icon-container {
        background: ${COLORS.primary};
      }
      .icon_drawer {
        fill: ${COLORS.blueFonts};
        stroke: ${COLORS.blueFonts};
      }

      .icon_drawer path {
        fill: ${COLORS.blueFonts};
        stroke: ${COLORS.blueFonts};
      }
    }
  }
`

export const Overflow = styled.div<IDrawerContent>`
  position: fixed;
  left: ${({ isOpen }) => (isOpen ? '14.8rem' : '5rem')};
  top: ${({ isOpen }) => (isOpen ? '13rem' : '7rem')};
  cursor: pointer;
  z-index: 9999;
`

export const SelectContainer = styled.div`
  margin: 1rem;
`

export const ListItemIconStyled = styled(ListItemIcon)``
